import {Controller} from "stimulus"
import $ from 'jquery';
import toastr from 'toastr/toastr'
import bootbox from 'bootbox';
import 'toastr/toastr.scss'
import * as Popper from '@popperjs/core'
import contains from "@popperjs/core/lib/dom-utils/contains";

import 'leaflet/dist/leaflet.css'
import 'leaflet'
import flatpickr from "flatpickr";

//Variables
let map = '';
let latlngs = [[23.966175871265044, -86.011962890625],
    [23.966175871265044, -73.72924804687501],
    [19.2489223284628, -73.72924804687501],
    [19.2489223284628, -86.011962890625]];


let session_type = '';
let session_destination = '';

let obtenerIdCheckDatatable = () => {
    let array = []
    let input = $('#table').find('input[type="checkbox"]');
    input.map(elem => {
        let check = $(input[elem]);
        if (check.is(':checked')) {
            if (check.val() !== 'on') {
                array.push(check.val());
            }
        }

    })
    return array;
}

let contar_caracteres = (max, counter, elem) => {

    //Numero de caracteres permitidos
    var total = max;
    var valor = document.getElementById(elem);
    var respuesta = document.getElementById(counter);
    var cantidad = valor.value.length;

    if (parseInt(cantidad) >= parseInt(total)) {
        valor.value = valor.value.slice(0, parseInt(max));
    }

    setTimeout(function (e) {
        document.getElementById(counter).innerHTML = cantidad + '/' + total;
        if (cantidad >= total) {
            respuesta.style.background = "#d43f34";
        } else {
            respuesta.style.background = "#6a6866";
        }
    }, 10);

}

let send_security_data = (data, method) => new Promise((resolve, reject) => {
    $.ajax({
        url: `${location.origin}/admin/security/edit`,
        data: data,
        type: method,
        success: function (result) {
            resolve(result);
        }
    })
})


export default class extends Controller {
    initialize() {
        jsColorPicker('.color-picker', {
            mode: 'rgb-b', // initial mode the color picker is starting with
            fps: 60, // the framerate colorPicker refreshes the display if no 'requestAnimationFrame'
            delayOffset: 8, // pixels offset when shifting mouse up/down inside input fields before it starts acting as slider
            CSSPrefix: 'cp-', // the standard prefix for (almost) all class declarations (HTML, CSS)
            size: 3, // one of the 4 sizes: 0 = XXS, 1 = XS, 2 = S, 3 = L (large); resize to see what happens...
            allMixDetails: true, // see Colors...
            noAlpha: true, // disable alpha input (all sliders are gone and current alpha therefore locked)
            cmyOnly: false, // display CMY instead of CMYK
            memoryColors: [{r: 100, g: 200, b: 10, a: 0.8}], // array of colors in memory section
            opacityPositionRelative: undefined, // render opacity slider arrows in px or %
            customCSS: undefined, // if external stylesheet, internal will be ignored...
            appendTo: document.body, // the HTMLElement the colorPicker will be appended to on initialization
            noRangeBackground: false, // performance option: doesn't render backgrounds in input fields if set to false
            textRight: false, // not supported yet. Make numbers appear aligned right
            noHexButton: false, // button next to HEX input could be used for some trigger...
            noResize: false, // enable / disable resizing of colorPicker
            noRGBr: true, // active / passive button right to RGB-R display. Disables rendering of 'real' color possibilities...
            noRGBg: true, // same as above
            noRGBb: true, // same as above
            CSSStrength: 'div.', // not in use
            devPicker: false
        });
        $('.color-picker').map((index, elem) => {
            $(elem).on('keyup', function (e) {
                e.currentTarget.style.background = e.currentTarget.value;
            })
        })

        //SIDEBAR
        $('#input-search').on('keyup', e => {
            let element_searchable = $(`${e.target.dataset.search}`).find('li.nav-item');
            let hidde_element = $(`${e.target.dataset.hide}`);
            if (hidde_element.length > 0) {
                if (e.target.value.length > 0) {
                    hidde_element.map((index, elem) => {
                        elem.classList.add('ocultar');
                        elem.classList.remove('d-flex');
                        elem.classList.remove('mt-4');
                        elem.classList.remove('mb-1');

                    })
                } else {
                    hidde_element.map((index, elem) => {
                        elem.classList.remove('ocultar');
                        elem.classList.add('d-flex');
                        elem.classList.add('mt-4');
                        elem.classList.add('mb-1');
                    })
                }
            }

            if (element_searchable.length > 0) {
                element_searchable.map((index, elem) => {
                    if (elem.outerText.toLowerCase().includes(e.target.value.toLowerCase())) {
                        elem.classList.remove('ocultar');
                        elem.parentNode.classList.add('mb-2')
                    } else {
                        elem.classList.add('ocultar');
                        elem.parentNode.classList.remove('mb-2')
                    }
                })
            }
        })

        if (location.pathname.includes('/admin/products')) {
            flatpickr('.datepicker', {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                minDate: new Date(),

            });

            $('#product_tipo').select2({
                theme: "bootstrap",
                language: "es"
            }).on('change', function (e) {
                let event_date = $('#events_date');
                if (e.target.value.includes('event')) {
                    event_date.removeClass('ocultar');
                } else {
                    event_date.addClass('ocultar');
                }
            })


        }

        //PAGES
        if (location.pathname.includes('admin/pages')) {
            let external_url = $('#page_isExternaUrl');
            if (external_url !== undefined && external_url !== null) {
                let fields = document.getElementById('fields');


                if (external_url.is(':checked')) {
                    // fields.style.display = 'none';
                }
            }

            let page_section_id = $('#page_section_id');
            if (page_section_id.length > 0 || true) {
                if (page_section_id.val() !== undefined) {
                    $.ajax({
                        url: `${location.origin}/admin/sections/${page_section_id.val()}.json`,
                        data: {},
                        type: 'get',
                        success: function (data) {
                            session_type = data.typesection;
                            session_destination = data.destination;
                            // if((data.typesection === 'presentation_with_image_left' || data.typesection === 'presentation-whit-image-right' || data.destination === 'footer') && !external_url.is(':checked')){

                            document.getElementById('page_icon').style.display = 'inline'
                            // }

                            if (data.typesection === 'presentation-notice-more-events') {
                                document.getElementById('page_with_events').style.display = 'inline';
                            }
                        }
                    })
                }
            }

        }

        //Notification PUSH
        if (location.pathname.includes('admin/notification_pushes')) {
            if (location.pathname.includes('new')) {
                let check_box_all = document.getElementById("notification_push_notify_all");
                check_box_all.checked = true;
            }

        }

        if (document.getElementById('setSecurityParams') !== null) {
            document.getElementById('setSecurityParams').addEventListener('click', () => {
                send_security_data({}, 'GET').then(result => {
                    bootbox.dialog({
                        message: `<form id="rack" name="rack">
                                    <div class="form-group mb-2">
                                        <label for="max_retry">Cantidad de intentos</label>
                                        <input id="max_retry" name="max_retry" type="number" value="${result.rack.max_retry}" min="1" max="15" step="1" class="form-control">
                                    </div>
                                    <div class="form-group mb-2">
                                        <label for="find_time">Tiempo para bloquear por cantidad de intentos</label>
                                        <input id="find_time" name="find_time" type="number" value="${result.rack.find_time}" min="1" class="form-control">
                                        <span class="text-muted " style="font-size: .8em">El tiempo se expresa en minutos</span>
                                    </div>
                                    <div class="form-group mb-2">
                                        <label for="ban_time">Tiempo de baneo</label>
                                        <input id="ban_time" name="ban_time" type="number" value="${result.rack.ban_time}" min="1"  class="form-control">
                                        <span class="text-muted " style="font-size: .8em">El tiempo se expresa en horas</span>
                                    </div>
                                </form>`,
                        buttons: {
                            ok: {
                                label: 'Guardar',
                                callback: function (e) {
                                    let send_data = {
                                        rack: {
                                            max_retry: document.getElementById('max_retry').value,
                                            find_time: document.getElementById('find_time').value,
                                            ban_time: document.getElementById('ban_time').value
                                        }
                                    }

                                    send_security_data(send_data, 'POST').then(r => {
                                        location.reload();
                                    })


                                }
                            }
                        }
                    })
                })
            })
        }
    }

    connect() {

        //    CAMBIOS EN LOS SELECT2 DE LA ADMINISTRACION
        $('#preference_behavior').on('change', function (e) {
            let valor = $(e.target).select2('data')[0].text;
            let elem_unblock = $('#type_' + valor);
            if (elem_unblock !== undefined) {
                elem_unblock.removeClass('ocultar').on('change', function (e) {
                    let other_valor = $(e.target).select2('data')[0].text;
                    let other_elemt_unblock = $('#type_' + other_valor);
                    if (other_elemt_unblock !== undefined) {
                        other_elemt_unblock.removeClass('ocultar');
                    }
                });
            }

        });

        //PREFERENCIAS
        $('#preference_key_id').select2({theme: "bootstrap"}).on('change', function (e) {
            let behavior = ''
            let block_imagen = document.getElementById('background_div');

            if ($(e.target).select2('data')[0].text.includes('social')) {
                behavior = 'social';
            } else {
                behavior = 'general';
            }

            if ($(e.target).select2('data')[0].text === 'Nombre del Sitio' || $(e.target).select2('data')[0].text === 'Bloque de presentación' || $(e.target).select2('data')[0].text === 'Nombre del sitio en el Footer' || $(e.target).select2('data')[0].text === 'Terminos y condiciones' || $(e.target).select2('data')[0].text === 'Politicas de Privacidad') {
                block_imagen.classList.remove('ocultar');
            } else {
                block_imagen.classList.add('ocultar');
            }


            $('#preference_behavior')[0].value = behavior;
        })


        //SECTION
        $('#section_typesection').select2({theme: "bootstrap"}).on('change', function (e) {
            let behavior = ''
            let thumbnail_div = document.getElementById('thumbnail_div');
            let background_div = document.getElementById('background_div');
            let section_top_div = document.getElementById('divider_top_div');
            let section_div_bottom = document.getElementById('divider_bottom_div');

            if ($(e.target).select2('data')[0].id === 'presentation-paralax-with-3-columns') {
                section_div_bottom.classList.remove('ocultar');
            } else {
                section_div_bottom.classList.add('ocultar');
                document.getElementById(section_div_bottom.dataset.clean).value = "";
                document.getElementById(section_div_bottom.dataset.clean).setAttribute('disabled', 'disabled');
                $('#' + section_div_bottom.dataset.uncheck).prop('checked', false);
            }

            if ($(e.target).select2('data')[0].id === 'presentation-information' || $(e.target).select2('data')[0].id === 'presentation-with-map' || $(e.target).select2('data')[0].id === 'presentation-gallery') {
                section_top_div.classList.add('ocultar');
                section_div_bottom.classList.add('ocultar');
                //LIMPIAR el TOP DIVIDER
                document.getElementById(section_top_div.dataset.clean).value = "";
                document.getElementById(section_top_div.dataset.clean).setAttribute('disabled', 'disabled');
                $('#' + section_top_div.dataset.uncheck).prop('checked', false);

                //LIMPIAR EL BOTTOM DIVIDER
                document.getElementById(section_div_bottom.dataset.clean).value = "";
                document.getElementById(section_div_bottom.dataset.clean).setAttribute('disabled', 'disabled');
                $('#' + section_div_bottom.dataset.uncheck).prop('checked', false);
            } else {
                section_top_div.classList.remove('ocultar');
                section_div_bottom.classList.remove('ocultar');
            }

            if ($(e.target).select2('data')[0].text.includes('footer')) {
                behavior = 'footer';

                section_top_div.classList.add('ocultar');
                section_div_bottom.classList.add('ocultar');
                //LIMPIAR el TOP DIVIDER
                document.getElementById(section_top_div.dataset.clean).value = "";
                document.getElementById(section_top_div.dataset.clean).setAttribute('disabled', 'disabled');
                $('#' + section_top_div.dataset.uncheck).prop('checked', false);

                //LIMPIAR EL BOTTOM DIVIDER
                document.getElementById(section_div_bottom.dataset.clean).value = "";
                document.getElementById(section_div_bottom.dataset.clean).setAttribute('disabled', 'disabled');
                $('#' + section_div_bottom.dataset.uncheck).prop('checked', false);

                //LIMPIAR Thumbnails
                thumbnail_div.classList.add('ocultar');
                document.getElementById(thumbnail_div.dataset.clean).value = "";
                document.getElementById(thumbnail_div.dataset.clean).setAttribute('disabled', 'disabled');
                $('#' + thumbnail_div.dataset.uncheck).prop('checked', false);

                //LIMPIAR Background image
                background_div.classList.add('ocultar');
                document.getElementById(background_div.dataset.clean).value = "";
                document.getElementById(background_div.dataset.clean).setAttribute('disabled', 'disabled');
                $('#' + background_div.dataset.uncheck).prop('checked', false);

            } else {
                behavior = 'body';
                thumbnail_div.classList.remove('ocultar');
                background_div.classList.remove('ocultar');
            }

            $('#section_destination')[0].value = behavior;
        })
        let section_external = $('#section_isExternaUrl');
        if (section_external !== undefined && section_external !== null) {
            let section_access_url = document.getElementById('section_access_url');
            let acces_url_value_sect = '';

            if (section_access_url !== undefined && section_access_url !== null) {
                acces_url_value_sect = section_access_url.value;
            }

            section_external.on('change', function (e) {
                if ($(e.target).is(':checked')) {
                    section_access_url.value = 'https://';
                } else {
                    section_access_url.value = acces_url_value_sect;
                }
            })
        }

        //PAGES
        let page_external = $('#page_isExternaUrl');
        if (page_external !== undefined && page_external !== null) {

            let fields = document.getElementById('fields');
            let access_url = document.getElementById('page_access_url');
            let acces_url_value = '';
            let page_icon = document.getElementById('page_icon');
            let tipo = document.getElementById('page_with_events');
            if (access_url !== undefined && access_url !== null) {
                acces_url_value = access_url.value;
            }


            page_external.on('change', function (e) {
                if ($(e.target).is(':checked')) {
                    access_url.value = 'https://';
                    // fields.style.display = 'none';
                    // page_icon.style.display = 'none';
                    // tipo.style.display = 'none';
                } else {

                    access_url.value = acces_url_value;
                    // fields.style.display = 'block';
                    if ((session_type === 'presentation_with_image_left' || session_type === 'presentation-whit-image-right' || session_destination === 'footer')) {

                        page_icon.style.display = 'inline';
                    }

                    if (session_type === 'presentation-notice-more-events') {
                        tipo.style.display = 'inline';
                    }
                }
            })
        }

        //NOTIFICATION PUSH
        let user_check = $('#notification_push_users_notification');
        if (user_check !== undefined && user_check !== null) {
            let users_select = document.getElementById('users_select');
            $('#notification_push_notify_all').on('change', function (e) {

                if ($(e.target).is(':checked')) {
                    users_select.style.display = 'none';
                } else {
                    users_select.style.display = 'block';
                }
            })
        }

        //IMFORMATION AND NOTICE
        $('#information_behavior').select2({theme: "bootstrap"}).on('change', function (e) {
            let value = $(e.target).select2('data')[0].id;
            let background_image = document.getElementById('background_image');
            if (value === 'notice') {
                background_image.classList.remove('ocultar');
            } else {
                background_image.classList.add('ocultar');
            }
        })
    }

    importData(e) {
        let url = location.origin + '/' + e.target.dataset.url;
        $.ajax({
            url: url,
            data: {},
            type: 'GET',
            success: function (data) {
                if (data.success) {
                    toastr.success(`(${data.count}) ${data.msg}`);
                    $('#table').bootstrapTable('refresh');
                } else {
                    toastr.error(`(${data.count}) ${data.msg}`);
                    $('#table').bootstrapTable('refresh');
                }

            }
        })
    }

    setActive(e) {
        let url = location.origin + '/' + e.target.dataset.url;
        $.ajax({
            url: url,
            data: {active: e.target.dataset.active},
            type: 'POST',
            success: function (data) {
                if (data.success) {
                    toastr.success(`${data.msg}`);
                    $('#table').bootstrapTable('refresh');
                    $('#admin_table').bootstrapTable('refresh');
                } else {
                    toastr.error(`${data.msg}`);
                }

            }
        })
    }

    setB2cRate(e) {
        let url = location.origin + '/' + e.target.dataset.url;
        $.ajax({
            url: url,
            data: {
                hotel_id: e.target.dataset.hotelId,
                rate_id: e.target.dataset.rateId,
                b2c: e.target.checked
            },
            type: 'POST',
            success: function (data) {
                if (data.success) {
                    toastr.success(`${data.msg}`);
                } else {
                    toastr.error(`${data.msg}`);
                }
            },
            error: function () {
                toastr.error('Error de conexión');
            }
        })
    }

    setMarketType(e) {
        let url = location.origin + '/' + e.target.dataset.url;
        let rateId = e.target.dataset.rateId;
        let commissionsSection = document.getElementById('commissions_rate_' + rateId);

        $.ajax({
            url: url,
            data: {
                hotel_id: e.target.dataset.hotelId,
                rate_id: rateId,
                market_type_id: e.target.value
            },
            type: 'POST',
            success: function (data) {
                if (data.success) {
                    toastr.success(`${data.msg}`);
                    if (commissionsSection) {
                        if (data.market_type_id) {
                            // Mercado asignado → mostrar tabla con valores en 0
                            commissionsSection.style.display = '';
                            commissionsSection.querySelectorAll('.commission-input').forEach(function(input) {
                                input.value = '0';
                            });
                        } else {
                            // Mercado quitado → ocultar tabla
                            commissionsSection.style.display = 'none';
                        }
                    }
                } else {
                    toastr.error(`${data.msg}`);
                }
            },
            error: function () {
                toastr.error('Error de conexión');
            }
        })
    }

    setCommission(e) {
        let input = e.target;
        let url = location.origin + '/' + input.dataset.url;
        let savedMsg = input.closest('tr').querySelector('.saved-msg');

        $.ajax({
            url: url,
            data: {
                hotel_id: input.dataset.hotelId,
                rate_id: input.dataset.rateId,
                currency_id: input.dataset.currencyId,
                percentage: input.value
            },
            type: 'POST',
            success: function (data) {
                if (data.success) {
                    if (savedMsg) {
                        savedMsg.style.display = 'inline';
                        setTimeout(function() {
                            savedMsg.style.display = 'none';
                        }, 2000);
                    }
                } else {
                    toastr.error(`${data.msg}`);
                }
            },
            error: function () {
                toastr.error('Error de conexión');
            }
        })
    }

    setBlockActive(e) {
        let ids = obtenerIdCheckDatatable();
        if (ids.length === 0) {
            toastr.info('Debe seleccionar al menos 1 elemento para continuar');
        } else {
            let url = location.origin + '/' + e.target.dataset.url;
            $.ajax({
                url: url,
                data: {id: ids},
                type: 'POST',
                success: function (data) {
                    if (data.success) {
                        toastr.success(`${data.msg}`);
                        $('#table').bootstrapTable('refresh');
                    } else {
                        toastr.error(`${data.msg}`);
                    }

                }
            })
        }

    }

    counter_characters(e) {
        contar_caracteres(e.target.dataset.max, e.target.dataset.counter, e.target.id);
    }

    showImg(e) {
        let src = document.getElementById(e.target.dataset.value).value
        bootbox.alert({
            message: `<img src='${src}' style='width: 100%'>`,
            buttons: {
                ok: {
                    label: "<span class='fa fa-check'></span> Visto",
                    className: 'btn-info'
                }
            }
        })
    }

    unblockElement(e) {
        let element = document.getElementById(e.target.id);
        let target = document.getElementById(e.target.dataset.target);
        let property = e.target.dataset.property;

        target.toggleAttribute(property)

        if (!$('#' + e.target.id).is(':checked')) {
            target.value = "";
            if (target.dataset.hasOwnProperty('target')) {
                let sub_target = document.getElementById(target.dataset.target);
                sub_target.classList.add('ocultar');
            }
        }
    }

    setAttributedata(e) {
        setTimeout(function () {
            let element = document.getElementById(e.target.id);
            let target = document.getElementById(e.target.dataset.target);
            target.setAttribute(e.target.dataset.property, element.value);

            if (element.value.isEmpty()) {
                target.classList.add('ocultar');
            } else {
                target.classList.remove('ocultar');
            }
        }, 100)


    }

    typeUrl(e) {
        let value = e.target.value.split(" ");
        e.target.value = value.join("-");
    }

    setColor(e) {
        let element = e.target;
        let value = element.value;
        let opacity30 = document.getElementById(e.target.dataset.opacity30);
        let opacity50 = document.getElementById(e.target.dataset.opacity50);
        let opacity80 = document.getElementById(e.target.dataset.opacity80);


        if (value.includes('#')) {
            if (opacity30 !== undefined && opacity30 !== null) {
                opacity30.value = `${value}5c`;
                opacity30.style.background = `${value}5c`;
            }
            if (opacity50 !== undefined && opacity50 !== null) {
                opacity50.value = `${value}BB`;
                opacity50.style.background = `${value}BB`;
            }
            if (opacity80 !== undefined && opacity80 !== null) {
                opacity80.value = `${value}DD`;
                opacity80.style.background = `${value}DD`;
            }
        }
    }

    copyForBackground(e) {
        var copyTextarea = document.createElement("textarea");
        copyTextarea.style.position = "fixed";
        copyTextarea.style.opacity = "0";
        copyTextarea.textContent = `${document.getElementById(e.target.dataset.id).value}`;

        document.body.appendChild(copyTextarea);
        copyTextarea.select();
        if (document.execCommand("copy")) {
            toastr.success('Url copiada al portapapeles!!!', 'Copiar url');
        } else {
            toastr.error('Upps ha ocurrido un error, no se pudo copiar la url.', 'Copiar url');
        }
        document.body.removeChild(copyTextarea);
    }

    deleteBlock(e) {
        let ids = obtenerIdCheckDatatable();
        if (ids.length === 0) {
            toastr.info('Debe seleccionar al menos 1 elemento para continuar');
        } else {
            bootbox.confirm({
                title: "Eliminar elementos",
                message: `¿Seguro que desea eliminar ${ids.length} elementos seleccionados?`,
                buttons: {
                    confirm: {
                        label: '<i class="fa fa-check"></i> Aceptar',
                        className: 'btn-danger'
                    },
                    cancel: {
                        label: '<i class="fa fa-times"></i> Cancelar',
                        className: 'btn-secondary'
                    }
                },
                size: 'small',
                callback: function (result) {
                    if (result) {
                        let url = location.origin + '/' + e.target.dataset.url;
                        $.ajax({
                            url: url,
                            data: {id: ids},
                            type: 'POST',
                            success: function (data) {
                                if (data.success) {
                                    toastr.success(`${data.msg}`);
                                    $('#table').bootstrapTable('refresh');
                                } else {
                                    toastr.error(`${data.msg}`);
                                }
                            }
                        })
                    }
                }
            })
        }

    }

    restoreBlock(e) {
        let ids = obtenerIdCheckDatatable();
        if (ids.length === 0) {
            toastr.info('Debe seleccionar al menos 1 elemento para continuar');
        } else {
            bootbox.confirm({
                title: "Restaurar elementos",
                message: `¿Seguro que desea restaurar ${ids.length} elementos seleccionados?`,
                buttons: {
                    confirm: {
                        label: '<i class="fa fa-check"></i> Aceptar',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: '<i class="fa fa-times"></i> Cancelar',
                        className: 'btn-secondary'
                    }
                },
                size: 'small',
                callback: function (result) {
                    if (result) {
                        let url = location.origin + '/' + e.target.dataset.url;
                        $.ajax({
                            url: url,
                            data: {id: ids},
                            type: 'POST',
                            success: function (data) {
                                if (data.success) {
                                    toastr.success(`${data.msg}`);
                                    $('#table').bootstrapTable('refresh');
                                } else {
                                    toastr.error(`${data.msg}`);
                                }
                            }
                        })
                    }
                }
            })
        }

    }


    sendToWhitelist(e) {
        $.ajax({
            url: `${location.origin}/admin/security/${e.target.dataset.ip}/send`,
            data: {},
            success: (result) => {
                if (result.success) {
                    toastr.success(result.msg);
                    $('#table').bootstrapTable('refresh');
                } else {
                    toastr.error(result.msg);
                }
            }
        })
    }

    sendToBlacklist(e) {
        $.ajax({
            url: `${location.origin}/admin/security/${e.target.dataset.ip}/send_black`,
            data: {},
            success: (result) => {
                if (result.success) {
                    toastr.success(result.msg);
                    $('#table').bootstrapTable('refresh');
                } else {
                    toastr.error(result.msg);
                }
            }
        })
    }

    checkUncheck(e) {
        let check_target = $(`#${e.target.dataset.target}`)
        check_target.prop('checked', e.target.checked).trigger('change')
    }

    show(e) {
        $.ajax({
            url: e.target.dataset.url,
            data: {
                /*seller: sessionStorage.getItem('seller')*/
            },
            type: "GET",
            success: function (data) {
                console.info('de vuelta al show');
                console.info(data);
                /*bootbox.dialog({
                    title: I18n.t('global.footer.term_and_conditions'),
                    message: `<div class="d-flex flex-column">
                                <div class="auto-heigt px-2 text-justify">
                                    ${data.terms}
                                </div>
                                <div class="form-inline border-top mt-3 py-4">
                                    <input type="checkbox" id="terms_and_condition_accepted" class="mr-2">
                                    <label for="terms_and_condition_accepted">Acepta nuestros terminos y condiciones</label>
                                </div>
                            </div>`,
                    size: 'large',
                    buttons: {
                        cancel: {
                            label: "Cancelar",
                            className: 'btn-secondary'
                        },
                        ok: {
                            label: "Aceptar",
                            className: 'btn-success',
                            callback: function (e) {
                                let check = $('#terms_and_condition_accepted');
                                if (check.is(':checked')) {
                                    resolve({
                                        success: true
                                    })
                                } else {
                                    toastr.warning('Debe acceptar nuestros terminos y condiciones para continuar', 'Términos y condiciones');
                                    return true;
                                }
                            }
                        }
                    }
                });*/
            }
        })
    }
}